import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { useMediaQuery } from 'react-responsive';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { OrderColumn } from 'src/components/Elements/Guess/GuessOrderDisplayer';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ccc',
  },
  items: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    height: '30px',
  },
  item: {
    padding: '0 4px',
  },
  quantity: {
    minWidth: '40px',
    width: '40px',
    padding: '0 4px',
  },
  product: {
    width: '100%',
    padding: '0 4px',
  },
  price: {
    minWidth: OrderColumn.price,
    width: OrderColumn.price,
    padding: '0 4px',
  },
  taxes: {
    minWidth: OrderColumn.taxes,
    width: OrderColumn.taxes,
    padding: '0 4px',
    paddingTop: '4px',
  },
  discount: {
    minWidth: OrderColumn.discount,
    width: OrderColumn.discount,
  },
  deductible: {
    minWidth: OrderColumn.deductible,
    width: OrderColumn.deductible,
  },
  amount: {
    minWidth: OrderColumn.amount,
    width: OrderColumn.amount,
    textAlign: 'right',
  },
  divider: {
    width: '1px',
    height: '20px',
    backgroundColor: 'rgba(0, 0, 0, .75)',
  },
}));

const GuessOrderDisplayerHeader = () => {
  const lang = useSelector((state: Store) => state.language.language);
  const classes = useStyles();

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 680px)' });

  const getColumnStyle = (column: string) => ({
    fontWeight: 'bold',
    padding: '0 8px',
    width: OrderColumn[column],
    minWidth: column === 'product' ? undefined : OrderColumn[column],
  } as CSSProperties);

  const showDesktop = () => (
    <div className={classes.container}>
      <div className={classes.items}>
        <div className={`${classes.item} ${classes.product}`}>
          <strong>{t(lang, 'forms.invoices.product')}</strong>
        </div>
        <div className={classes.divider} />
        <div className={`${classes.item} ${classes.deductible}`}>
          <strong>{t(lang, 'forms.invoices.deductible')}</strong>
        </div>
        <div className={classes.divider} />
        <div className={`${classes.item} ${classes.price}`}>
          <strong>{t(lang, 'forms.invoices.price')} - {t(lang, 'forms.invoices.discount')}</strong>
        </div>
        <div className={classes.divider} />
        <div className={`${classes.item} ${classes.amount}`}>
          <strong>{t(lang, 'forms.invoices.amount')}</strong>
        </div>
      </div>
    </div>
  );

  const showTablet = () => (
    <div style={{
      marginTop: '16px',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0.1)',
      height: '40px',
    }}>
      <div style={getColumnStyle('product')}>
        {t(lang, 'forms.invoices.product')}
      </div>
      <div style={getColumnStyle('amount')}>
        {t(lang, 'forms.invoices.amount')}
      </div>
    </div>
  );

  return isTabletOrMobile ? showTablet() : showDesktop();
};

export default GuessOrderDisplayerHeader;
